import script from "./MmProductCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MmProductCard.vue?vue&type=script&setup=true&lang=js"

import "./MmProductCard.vue?vue&type=style&index=0&id=26070877&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26070877"]])

export default __exports__